import { resultSort } from "init/sort";
import { ICardElementWithChildren } from "./model/model";

const flattenHierarchy = (list?: ICardElementWithChildren[]) => {
  if (!list) {
    return [];
  }
  const res: ICardElementWithChildren[] = [];
  const walk = (elems: ICardElementWithChildren[]) => {
    elems.forEach((el) => {
      res.push(el);
      if (el.children) walk(el.children);
    });
  };
  walk(list);
  return resultSort(res);
};

export default flattenHierarchy;
